import React, { useState, useRef } from "react";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";

export default function SpeechPage() {
    const azureKey = process.env.REACT_APP_AZURE_AI_SPEECH_KEY;
    const azureRegion = process.env.REACT_APP_AZURE_AI_SPEECH_REGION;

    const [recognizedSentences, setRecognizedSentences] = useState([]);
    const [isRecognizing, setIsRecognizing] = useState(false);
    const [status, setStatus] = useState("Click 'Start Recognition' to begin.");
    const recognizerRef = useRef(null);

    const startRecognition = () => {
        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(azureKey, azureRegion);
        speechConfig.speechRecognitionLanguage = "en-US";
        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

        recognizer.recognizing = (s, e) => {
            // Optionally handle partial results
        };

        recognizer.recognized = (s, e) => {
            if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                setRecognizedSentences(prev => [...prev, e.result.text]);
            }
        };

        recognizer.canceled = (s, e) => {
            setStatus("Recognition canceled.");
            recognizer.stopContinuousRecognitionAsync();
            setIsRecognizing(false);
        };

        recognizer.sessionStopped = (s, e) => {
            setStatus("Recognition stopped.");
            recognizer.stopContinuousRecognitionAsync();
            setIsRecognizing(false);
        };

        recognizer.startContinuousRecognitionAsync();
        recognizerRef.current = recognizer;
        setIsRecognizing(true);
        setStatus("Recognition started...");
    };

    const stopRecognition = () => {
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                recognizerRef.current.close();
                recognizerRef.current = null;
                setIsRecognizing(false);
                setStatus("Recognition stopped.");
            });
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h1>Speech Recognition with Azure Cognitive Services</h1>
            <button onClick={startRecognition} disabled={isRecognizing}>
                Start Recognition
            </button>
            <button onClick={stopRecognition} disabled={!isRecognizing}>
                Stop Recognition
            </button>
            <p>{status}</p>
            <br />
            <div>
                <h3>Recognized Sentences:</h3>
                <ul>
                    {recognizedSentences.map((sentence, index) => (
                        <li key={index}>{sentence}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
